import { createContext, ReactNode, useState } from "react";

interface LoanApplicationData {
    loanApplicationId: string;
    setLoanApplicationId: React.Dispatch<string>;
}

interface ProviderProps {
    children: ReactNode;
}

export const LoanApplicationContext = createContext<LoanApplicationData>(null);

export function LoanApplicationProvider ({ children }: ProviderProps) {
    const [loanApplicationId, setLoanApplicationId] = useState<string>();

    return (
        <LoanApplicationContext.Provider value={{
            loanApplicationId,
            setLoanApplicationId
        }}>
            {children}
        </LoanApplicationContext.Provider>
    )
}
